<section style="background: #f1f1f1;">
  <nav class="navbar navbar-light justify-content-between"
    style="background: white;padding: 0px !important;    height: 66px;">
    <a class="navbar-brand" routerLink="#">
      <img src="../../../assets/images/logo.png" class="logo"> </a>

    <form class="form-inline form-styles">
      <ul>
        <div class="nav-item dropdown d-none d-md-block">
          <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" style="color: black;   font-size: 17px; margin-top: 9px;">
            {{this.createdBy.userName}}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" routerLink="/dashboardmain-admin">Dashboard</a>
            <a class="dropdown-item" routerLink="/changepwd-admin">Change Password</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" data-toggle="modal" data-target="#myModal" style="cursor: pointer;">Logout</a>
          </div>
        </div>
      </ul>
    </form>
  </nav>

  <div class="row">
    <div class="col-sm" style="height: 10px;"></div>
    <div class="col-md" style="height: 10px"></div>
  </div>

  <nav class="navbar navbar-expand-lg navbar-dark bg-dark" style="padding: 4px !important;">
    <button class="navbar-toggler ml-auto py-2" type="button" data-toggle="collapse"
      data-target="#navbarSupportedContent">
      ☰
    </button>
    <div class="container-fluid">
      <div class="collapse navbar-collapse navbar-right-line" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link dropdown-main" routerLink="/dashboardmain-admin"><i class="fa fa-home"
                aria-hidden="true"></i>&nbsp;Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-main" id="navbarDropdown" type="button"
              data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-users" aria-hidden="true"></i>&nbsp;Manage Clients
            </a>
            <div class="dropdown-menu dropdown-open" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" routerLink="/all-clients">All Clients</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/clients-documents">Clients Documents</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-main" id="navbarDropdown" type="button"
              data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-file-text" aria-hidden="true"></i>&nbsp;Manage Return Tax
            </a> 
            <div class="dropdown-menu dropdown-open" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" routerLink="/upload-return-tax-admin">Upload Return Tax</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/manage-return-tax">Manage Return Tax</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-main" id="navbarDropdown" type="button"
              data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-user-secret" aria-hidden="true"></i>&nbsp;Manage Zone Admins
            </a>
            <div class="dropdown-menu dropdown-open" aria-labelledby="navbarDropdown">
              <div *ngIf="createdBy.userType=== 'SUPER_ADMIN'">
                <a class="dropdown-item" routerLink="/zoneadmin-admin">Add Zone Admin</a>
              </div>
              <div class="dropdown-divider" *ngIf="createdBy.userType=== 'SUPER_ADMIN'"></div>

              <a class="dropdown-item" routerLink="/manage-zone-admin">Manage Zone Admin</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-main" id="navbarDropdown" type="button"
              data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-user-plus" aria-hidden="true"></i>&nbsp;Manage Leads
            </a>
            <div class="dropdown-menu dropdown-open" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" routerLink="/bulkUploads">Leads Bulk Upload</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/addLeads">Add Leads</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/manageLeads">Manage Leads</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle dropdown-main" id="navbarDropdown" type="button"
              data-toggle="dropdown" data-hover="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-wrench" aria-hidden="true"></i>&nbsp;Settings
            </a>
            <div class="dropdown-menu dropdown-open" aria-labelledby="navbarDropdown">
              <a class="dropdown-item" routerLink="/manage-category-admin">Manage Category</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/view-contactus-admin">View ContactUs</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/view-referral-admin">View Referral History</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/view-fileDownload-admin">View File Download History</a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" routerLink="/viewLeadHistory">View Lead History</a>
            </div>
          </li>
          <li class="nav-item" *ngIf="createdBy.userType=== 'SUPER_ADMIN'">
            <a class="nav-link dropdown-main" routerLink="/wishlist"><i class="fa fa-home"
                aria-hidden="true"></i>&nbsp;Ip Whishlists</a>
          </li>

          <li class="header-admin d-md-none">
            <div class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" style="color:white;   font-size: 17px; margin-top: 9px;">
                {{this.createdBy.userName}}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" routerLink="/dashboardmain-admin">Dashboard</a>
                <a class="dropdown-item" routerLink="/changepwd-admin">Change Password</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" data-toggle="modal" data-target="#myModal" style="cursor: pointer;">Logout</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>

  <div class="modal" id="myModal">
    <div class="modal-dialog modal-logout-width">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title title-logout-left">Are You Sure</h4>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>

        <!-- Modal body -->
        <div class="modal-body modal-logout-left">
          Do You Want To LogOut
        </div>

        <!-- Modal footer -->
        <div class="modal-footer" style="text-align: center;">
          <button type="button" (click)="logout()" class="btn btn-success btn-success-right"
            data-dismiss="modal">Confirm</button>
          <button type="button" class="btn btn-danger btn-danger-right" data-dismiss="modal">Close</button>
        </div>

      </div>
    </div>
  </div>
</section>